<script lang="ts">
	import type { SbImage, SbLink } from '$lib/storyblok/types';
	import Button from '$lib/buttons/v3/button.svelte';
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '$lib/storyblok/editable';
	import type { HTMLAttributes } from 'svelte/elements';
	import Blok from '$lib/storyblok/blok.svelte';

	interface Props extends HTMLAttributes<HTMLDivElement> {
		content: ISbStoryData<{
			articles: Array<ISbStoryData<{ logo: SbImage; link: SbLink }>>;
			display_reviews_button: boolean;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<section class="bg-white pb-32" use:editable={content}>
	<div class="flex w-full flex-col items-center justify-center lg:mx-auto lg:max-w-[1400px]">
		<h1
			class="mb-5 text-center text-[12px]/[100%] font-semibold uppercase tracking-[.96px] text-brown-1/60 lg:mb-4 lg:text-[14px]/[140%] lg:tracking-[1.12px]"
		>
			Featured in<span class="lg:hidden">:</span>
		</h1>
		<div class="flex flex-wrap items-center justify-center gap-x-6 gap-y-4 lg:gap-x-8 lg:gap-y-5">
			{#each content.articles as article}
				<Blok content={article} />
			{/each}
		</div>
		{#if content.display_reviews_button}
			<Button class="btn-large btn-secondary btn-brown mt-12" href="/reviews"
				>See all reviews</Button
			>
		{/if}
	</div>
</section>
